'use strict';

require("core-js/modules/es6.array.index-of");

module.exports = footnoteReference;

var u = require('unist-builder');

function footnoteReference(h, node) {
  var footnoteOrder = h.footnoteOrder;
  var identifier = String(node.identifier);

  if (footnoteOrder.indexOf(identifier) === -1) {
    footnoteOrder.push(identifier);
  }

  return h(node.position, 'sup', {
    id: 'fnref-' + identifier
  }, [h(node, 'a', {
    href: '#fn-' + identifier,
    className: ['footnote-ref']
  }, [u('text', node.label || identifier)])]);
}